import { Layout, useBaseStore, useUserStore } from '@roc/feature-app-core';
import {
  useLoanStore,
  LoanTabs,
  MyRequestLoansGrid,
  MyTasksGridExternal
} from '@roc/feature-loans';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { MyLoansBackOfficeGrid } from '../backOfficeGrid/myLoansBackOfficeGrid';
import { useBackOfficeLoansStore } from '../../hooks/useBackOfficeLoansStore';
import { insertIf } from '@roc/feature-utils';
import { MyManualQuoteLoansBackofficeGrid } from '../backOfficeGrid/myManualQuoteLoansBackOfficeGrid'
import { MyLoansInBackOfficeViewGrid } from '../backOfficeGrid/myLoansInBackOfficeViewGrid';
import { MyTasksBackOfficeGrid } from '../backOfficeGrid/myTasksBackOfficeGrid';
import { MyTasksTabActions } from '../backOfficeGrid/myTasksTabActions';
import { MyAgreedLoansBackOfficeGrid } from '../backOfficeGrid/myAgreedLoansBackOfficeGrid';
import { myRequestLoansColumns, myPendingApprovalLoansColumns } from './columns';


const renderTabContent = (globalStore, loanStore) => {
  const { backOfficeLoansStore } = useBackOfficeLoansStore();
  const { userStore } = useUserStore();
  console.log("LoanStore selected: " + loanStore.selectedTabIndex)
  switch (loanStore.selectedTabIndex) {
    case 0:
      return globalStore.isListView ? <MyTasksGridExternal isFromBackOfficeView={true} /> : null;
    case 1:
      return globalStore.isListView ? <MyLoansBackOfficeGrid store={backOfficeLoansStore.pipelineBackOfficeLoansGridStore} /> : null;
    case 2:
      return globalStore.isListView ? <MyAgreedLoansBackOfficeGrid store={backOfficeLoansStore} /> : null;
    case 3:
      return globalStore.isListView ? <MyManualQuoteLoansBackofficeGrid /> : null;
    case 4:
      if (userStore.isBackofficeLead) {
        return globalStore.isListView ? <MyLoansBackOfficeGrid filteredByBorrower store={backOfficeLoansStore.pipelineBackOfficeLoansGridStore} /> : null;
      }
      return globalStore.isListView ? <MyLoansBackOfficeGrid store={backOfficeLoansStore.primaryBackOfficeLoansGridStore} /> : null;
    case 5:
      return globalStore.isListView ? <MyLoansBackOfficeGrid store={backOfficeLoansStore.secondaryBackOfficeLoansGridStore} /> : null;
    case 6:
      return globalStore.isListView ? <MyLoansInBackOfficeViewGrid store={backOfficeLoansStore.myLoansGridStore} /> : null;
    default:
      console.error('Invalid tab index');
      break;
  }
};

export const BackOfficeLoansHome = observer(() => {
  const { globalStore } = useBaseStore();
  const { loanStore } = useLoanStore();
  const { userStore } = useUserStore();
  const { selectedTabIndex } = loanStore;
  const { backOfficeLoansStore } = useBackOfficeLoansStore();

  useEffect(() => {
    const isComingBackFromLoanDetails = globalStore.lastHistoryAction === 'POP';
    if (!isComingBackFromLoanDetails) {
      loanStore.setSelectedTabIndex(0);
    }
  }, []);

  useEffect(() => {
    if (TABS[selectedTabIndex]?.label === 'MY TASKS') {
      loanStore.setShouldReloadPageOnGetLoan(false);
    }
    else {
      loanStore.setShouldReloadPageOnGetLoan(true);
    }
  }, [selectedTabIndex]);

  useEffect(() => {
    return () => {
      loanStore.setShouldReloadPageOnGetLoan(true);
    };
  }, []);

  const TABS = [
    {
      label: "MY TASKS",
    },
    {
      label: 'PIPELINE',
    },
    {
      label: 'AGREED LOANS',
    },
    {
      label: 'MANUAL QUOTES',
    },
    ...insertIf(userStore.isBackofficeOriginator, [
      {
        label: 'PRIMARY',
      },
      {
        label: 'SECONDARY'
      },
      {
        label: 'MY LOANS'
      },
    ]),
  ];
  const showSwitchView = () => {
    switch (selectedTabIndex) {
      case 1:
        return true;
      default:
        return false;
    }
  };

  return (
    <Layout>
      <LoanTabs tabs={TABS} showSwitchView={showSwitchView} />
      {renderTabContent(globalStore, loanStore)}
    </Layout>
  );
});